import { IGNORE_ROUTES } from "@/constants/analitics.js";

const hasMetrika = () => {
  return window.hasOwnProperty('yaCounter93736397') && window.hasOwnProperty('ym')
}

export default function ({ route, store, error, app, env }) {
  const routePermission = route.meta[0]?.permission ?? false
  if (routePermission && !routePermission.includes(store.$auth?.user?.role ?? "")) {
    return error({ statusCode: 403 })
  }

  if (process.client && app.__rolesScrollBehaviorRegistered) {
    return
  }

  if (process.client) {
    app.__rolesScrollBehaviorRegistered = true
  }

  app.router.options.scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    }
    if (to.meta.noScroll) return false
    return { x: 0, y: 0 };
  }
}
